'use strict';

import { find, findAll, register } from '../../../../JavaScript/Utils';

const Mobile = $el => {
  const $mobileNav = $el;
  const $html = find('html', document);
  const $menuBtnOpen = find('[data-nezzo-btn-menu-open]', $mobileNav);
  const $menuItems = findAll('[data-nezzo-menu-open-level]', $mobileNav);
  const $backItems = findAll('[data-nezzo-menu-back]', $mobileNav);
  const $currentItem = find('[data-nezzo-menu-current]', $mobileNav);
  const $footer = find('footer.internezzoOrganismFooter', document);
  const $navMobileWrapper = find('.nav__mobile--list-wrapper', $mobileNav);
  const classMainNavOpen = 'mobile-nav-open';
  const classMainNavSubOpen = 'mobile-nav-open-sub';

  const handleFooter = (action) => {
    if (action === 'append' && $footer && $navMobileWrapper) {
      $footer.style.overflowY = 'visible';
      $navMobileWrapper.appendChild($footer);
    } else if (action === 'remove' && $footer && document.body) {
      document.body.appendChild($footer);
    }
  };

  function openActiveMenuTree() {
    const activeLink = find('[data-nezzo-menu-current]', $mobileNav);
    if (!activeLink) {
      return;
    }

    let currentElement = activeLink;
    let i = 0;

    while (currentElement && !currentElement.matches('.nav__mobile-main--list')) {
      if (currentElement.classList.contains('nav__mobile-item--wrapper-sub')) {
        let siblingElement = currentElement.previousElementSibling;
        if (!currentElement.classList.contains('open')) {
          currentElement.classList.add('open');
          siblingElement.classList.add('sub-item-open');
          if (i < 1) {
            let childElement = siblingElement.getElementsByTagName('span')[0];
            childElement.classList.add('last_clicked');
            i++;
          }
        }
      }
      currentElement = currentElement.parentElement;
    }

    // Add or remove line on level3 menu
    const listItemElement = $('li.nav__mobile-sub-2--item:has(span.sub-item-open)');
    const subItemOpen = $('ul.nav__mobile-item--sub-3:has(a.sub-item-open');
    const listElement = listItemElement.find('div > ul.nav__mobile-item--sub-3');

    if (subItemOpen.length != 0) {
      listElement.removeClass('line');
    } else {
      listElement.addClass('line');
    }

  }

  $menuBtnOpen.addEventListener('click', () => {
    $html.classList.toggle(classMainNavOpen);
    if ($html.classList.contains(classMainNavOpen)) {
      openActiveMenuTree();
    }

    if ($currentItem) {
      $html.classList.toggle(classMainNavSubOpen);
    }
  });
};
register('Mobile', Mobile);
document.addEventListener('DOMContentLoaded', () => {

  // Function to toggle submenu
  function toggleSubmenu(submenu) {
    // Remove 'last_clicked' class from all submenu titles and 'item_parent' from all parents
    document.querySelectorAll('.sub-item-open').forEach(link => {
      const spanInside = link.querySelector('span');
      if (spanInside) {
        spanInside.classList.remove('last_clicked');
      }
    });
    document.querySelectorAll('.item_parent').forEach(parent => {
      parent.classList.remove('item_parent');
    });

    // Close submenus that are not in the current path
    const allSubmenus = document.querySelectorAll('.nav__mobile-item--wrapper-sub');
    allSubmenus.forEach(sub => {
      if (!submenu.contains(sub) && !sub.contains(submenu)) {
        sub.classList.remove('open');
        sub.previousElementSibling.classList.remove('sub-item-open');
        sub.style.maxHeight = null;
      }

      // Remove 'item_parent' from elements not in the active path
      let parentElement = sub.parentElement;
      while (parentElement && !parentElement.matches('.nav__mobile-main--list')) {
        if (!submenu.contains(parentElement) && !parentElement.contains(submenu)) {
          parentElement.classList.remove('item_parent');
        }
        parentElement = parentElement.parentElement;
      }
    });

    // Toggle the current submenu
    if (submenu.classList.contains('open')) {
      submenu.classList.remove('open');
      submenu.previousElementSibling.classList.remove('sub-item-open');
      submenu.style.maxHeight = null;
    } else {
      submenu.classList.add('open');
      submenu.previousElementSibling.classList.add('sub-item-open');
      // Add 'last_clicked' class to the previous element's span, if it exists
      const spanInside = submenu.previousElementSibling.querySelector('span');
      if (spanInside) {
        spanInside.classList.add('last_clicked');
      }
    }

    // Add 'item_parent' class to all parent elements in the tree of the clicked submenu
    let currentElement = submenu;
    while (currentElement && !currentElement.matches('.nav__mobile-main--list')) {
      currentElement.classList.add('item_parent');
      currentElement = currentElement.parentElement;
    }
  }

  // Attach click event to Level 1 items to toggle submenus
  document.querySelectorAll('.nav__mobile--item-link').forEach((item) => {
    let clickCount = 0;
    const clickDelay = 300; // Delay between clicks to distinguish single from double click

    item.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent default action to control behavior manually
      clickCount++;

      const parent = this.parentElement;
      const submenu = parent.querySelector('.nav__mobile-item--wrapper-sub');

      setTimeout(() => {
        if (clickCount === 1) {
          // Single click: check submenu
          if (submenu) {
            // If submenu exists, toggle it
            toggleSubmenu(submenu);
          } else {
            // If no submenu, open the link
            window.location.href = this.attributes.href.value;
          }
        } else if (clickCount === 2) {
          // Double click: open the link
          window.location.href = this.attributes.href.value;
        }
        // Reset click count after handling
        clickCount = 0;
      }, clickDelay);
    });
  });

  // Attach click event to Level 2 items to toggle submenus
  document
    .querySelectorAll('.nav__mobile-sub-2--item-title')
    .forEach((item) => {
      let clickCount = 0;
      const clickDelay = 300; // Delay between clicks to distinguish single from double click

      item.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default action to control behavior manually
        clickCount++;

        const parent = this.parentElement;
        const submenu = parent.querySelector('.nav__mobile-item--wrapper-sub');

        setTimeout(() => {
          if (clickCount === 1) {
            // Single click: check submenu
            if (submenu) {
              // If submenu exists, toggle it
              toggleSubmenu(submenu);
            } else {
              // If no submenu, open the link
              window.location.href = this.attributes.href.value;
            }
          } else if (clickCount === 2) {
            // Double click: open the link
            window.location.href = this.attributes.href.value;
          }
          // Reset click count after handling
          clickCount = 0;

          const child = submenu.querySelector('.nav__mobile-item--sub-3');
          const grandChildElement = child.querySelector('div.open');
          
          if(child.classList.contains('line') || grandChildElement) {
            child.classList.remove('line')
          } else {
            child.classList.add('line')
          }
        }, clickDelay);
      });
    });

  // Attach click event to Level 3 items to toggle submenus
  document
    .querySelectorAll('.nav__mobile-sub-3--item-title')
    .forEach((item) => {
      let clickCount = 0;
      const clickDelay = 300; // Delay between clicks to distinguish single from double click

      item.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default action to control behavior manually
        clickCount++;

        const parent = this.parentElement;
        const grandparent = parent.parentElement;
        const submenu = parent.querySelector('.nav__mobile-item--wrapper-sub');

        setTimeout(() => {
          if (clickCount === 1) {
            // Single click: check submenu
            if (submenu) {
              // If submenu exists, toggle it
              toggleSubmenu(submenu);
            } else {
              // If no submenu, open the link
              window.location.href = this.attributes.href.value;
            }
          } else if (clickCount === 2) {
            // Double click: open the link
            window.location.href = this.attributes.href.value;
          }
          // Reset click count after handling
          clickCount = 0;

        // Add or remove line on level3 menu
        if(!this.classList.contains('sub-item-open')) {
          grandparent.classList.add('line');
        } else {
          grandparent.classList.remove('line')
        }
        }, clickDelay);
      });
    });

  document.querySelectorAll('.nav__mobile--item span, .nav__mobile--item a, .header__row--nav-mobile  .nav__main-sub-2--item-title').forEach(element => {
    let href = element.getAttribute('href');

    // If the element doesn't have an href attribute, look for an anchor tag inside it
    if (!href) {
      const anchor = element.querySelector('a');
      href = anchor ? anchor.getAttribute('href') : null;
    }

    // Add the 'have-link' class if a valid href is found
    if (href && href !== '#') {
      element.classList.add('have-link');

    }
  });

});
